import React from "react";
import LeftSidebar from "./left-sidebar";
import RightSidebar from "./right-sidebar";
import Map from "./map";

class NorthRegion extends React.Component {
  render() {
    const { height } = this.props;
    return (
      <div
        className="north-container"
        style={{
          position: "relative",
          height: height,
          left: 0,
          right: 0,
          top: 0
        }}
      >

        <LeftSidebar />

        <RightSidebar />

        <Map />

      </div>
    );
  }
}

export default NorthRegion;